var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPause0 = function SvgIconPause0(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "M18.869 38H29V0H18.869v38zM0 38h10.131V0H0v38z"
  })));
};
export default SvgIconPause0;